import {
  Avatar,
  Box,
  Burger,
  Button,
  Center,
  Flex,
  NavLink,
  Space,
  Stack,
  Title,
  rem,
} from "@mantine/core";
import {
  IconDatabasePlus,
  IconLayoutDashboard,
  IconLogout,
} from "@tabler/icons-react";
import styles from "../../styles/sidebar.module.css";
import { nprogress } from "@mantine/nprogress";
import { Link, useLocation } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import { getFirstName } from "../../utils/strings";
import { routePaths } from "../../constants/paths";
import { useSessionStore } from "../../store/session.store";
import { User } from "../../types";
import { ROLES } from "../../constants";

type SideBarProps = {
  toggleSidebar: () => void;
  isSidebarOpened: boolean;
};

const data = (user: User) => [
  {
    icon: IconLayoutDashboard,
    label: "Dashboard",
    url: routePaths.dashboard,
    show: true,
  },
  {
    icon: IconDatabasePlus,
    label: "Register",
    url: routePaths.register,
    show: user?.designation?.toLowerCase() === ROLES.ADMIN?.toLowerCase(),
  },
];

export default function MainSidebar({
  toggleSidebar,
  isSidebarOpened,
}: SideBarProps) {
  const user = useSessionStore((state) => state.user);
  const { logoutUser } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  const items = data(user as User)
    .filter((item) => item.show)
    .map((item, index) => (
      <NavLink
        component={Link}
        key={index}
        active={item.url === pathname}
        label={item.label}
        leftSection={<item.icon size={20} stroke={1.5} />}
        to={item.url}
        variant="subtle"
        className={styles["nav-item"]}
        onClick={() => {
          nprogress.start();
        }}
      />
    ));

  return (
    <Flex direction={"column"} h={"100%"} bg={"#06367A"}>
      <Box p={"md"}>
        <Flex hiddenFrom="sm" justify={"flex-end"}>
          <Burger
            opened={isSidebarOpened}
            onClick={toggleSidebar}
            size="sm"
            color="white"
          />
        </Flex>

        <Center>
          <Flex direction={"column"} justify={"center"} align={"center"}>
            <Title ta={"center"} order={3} c={"white"}>
              Hello {getFirstName(user?.name || "")}
            </Title>
            <Space h="sm" />
            <Avatar size={80} name={user?.name} color="initials"></Avatar>
          </Flex>
        </Center>
        <Space h="xl" />
        <Box>
          <Stack gap={"4px"}>{items}</Stack>
        </Box>
      </Box>
      <Button
        fullWidth
        radius={0}
        leftSection={<IconLogout size={20} stroke={1.5} />}
        mt={"auto"}
        variant="filled"
        bg={"pink"}
        h={rem(45)}
        onClick={() => {
          nprogress.start();
          logoutUser();
        }}
      >
        Log out
      </Button>
    </Flex>
  );
}
